// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","512":"87b53093","680":"44761238","909":"b0dcefaa","980":"4bb5437a"}[chunkId] + ".chunk.js";
};